export class AdminService {
  constructor(API, Auth, ItCache) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.ItCache = ItCache;
  }

  getCountries() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/countries'
    });
  }

  addCountry(newCountry) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/countries',
      headers: {
        'Content-Type': 'application/json',
      },
      data: newCountry
    });
  }

  updateCountry(name, country) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/countries/' + name,
      headers: {
        'Content-Type': 'application/json',
      },
      data: country
    });
  }

  getCountry(name) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/countries/' + name
    });
  }

  getHolidays(name) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/countries/' + name + '/holidays'
    });
  }

  addNewHoliday(id, date) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/admin/sites/' + id + '/holidays',
      data: {dates: [date]}
    });
  }

  deleteHoliday(id, date) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/sites/' + id + '/holidays/' + date
    });
  }

  getInterrupts() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/interrupts',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  getInterrupt(uuid) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/interrupts/' + uuid,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addInterrupt(interrupt) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/interrupts',
      headers: {
        'Content-Type': 'application/json'
      },
      data: interrupt
    });
  }

  updateInterrupt(uuid, name) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/interrupts/' + uuid,
      headers: {
        'Content-Type': 'application/json'
      },
      data: name
    });
  }

  deleteInterrupt(uuid) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/interrupts/' + uuid,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  getGroups() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/processGroups',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addGroup(group) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/processGroups',
      headers: {
        'Content-Type': 'application/json'
      },
      data: group
    });
  }

  updateGroup(id, name) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/processGroups/' + id,
      headers: {
        'Content-Type': 'application/json'
      },
      data: name
    });
  }

  deleteGroup(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/processGroups/' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  getGroupCountryConfigurations(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/processGroupCountryConfigurations/' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addGroupCountryConfiguration(configuration) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/processGroupCountryConfigurations',
      headers: {
        'Content-Type': 'application/json'
      },
      data: configuration
    });
  }

  updateGroupCountryConfiguration(id, configuration) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/processGroupCountryConfigurations/' + id,
      headers: {
        'Content-Type': 'application/json'
      },
      data: configuration
    });
  }

  deleteGroupCountryConfiguration(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/processGroupCountryConfigurations/' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  getGroupCountryProcesses(uuid) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/processGroupCountryConfigurations/' + uuid + '/process',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addGroupCountryProcess(countryProcess) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/processes',
      headers: {
        'Content-Type': 'application/json'
      },
      data: countryProcess
    });
  }

  updateGroupCountryProcess(id, countryProcess) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/processes/' + id,
      headers: {
        'Content-Type': 'application/json'
      },
      data: countryProcess
    });
  }

  deleteGroupCountryProcess(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/processes/' + id,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  getDefaultProcessConfigurationForTeam(uuid) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/team/' + uuid + '/defaultProcessClientConfigurations',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  addProcessForClientInTeam(id, client) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/teams/' + id + '/processClientConfigurations',
      headers: {
        'Content-Type': 'application/json'
      },
      data: client
    });
  }

  deleteProcessForClientInTeam(teamId, clientId, pgccId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/teams/' + teamId + '/clients/' + clientId + '/processGroupCountryConfigurations/' + pgccId
    });
  }

  getInterruptCountryConfiguration() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/interruptcountryconfigurations'
    });
  }

  addInterruptCountryConfiguration(interrupt) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/interruptCountryConfigurations',
      data: interrupt
    });
  }

  updateInterruptCountryConfiguration(id, interrupt) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/interruptCountryConfigurations/' + id,
      data: interrupt
    });
  }

  deleteInterruptCountryConfiguration(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/interruptCountryConfigurations/' + id
    });
  }

  getClients() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/clients'
    });
  }

  addClient(client) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/clients',
      data: client
    });
  }

  updateClient(id, client) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/admin/clients/' + id,
      data: client
    });
  }

  deleteClient(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/clients/' + id
    });
  }

  getClientGroups() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/clientGroups'
    });
  }

  addClientGroup(clientGroup) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/clientGroups',
      data: clientGroup
    });
  }

  updateClientGroup(id, clientGroup) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/clientGroups/' + id,
      data: clientGroup
    });
  }

  deleteClientGroup(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/clientGroups/' + id
    });
  }

  getServiceLines() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/serviceLines'
    });
  }

  addServiceLine(serviceLine) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/serviceLines',
      data: serviceLine
    });
  }

  getUsers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/users'
    });
  }

  getUsersTeam(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/users/' + userId + '/team-changelogs'
    });
  }

  setUsersTeam(userId , data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/users/' + userId + '/team-changelogs',
      data: data
    });
  }

  editUsersTeam(userId, teamId , data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/users/' + userId + '/team-changelogs/' + teamId,
      data: data
    });
  }

  deleteUsersTeam(userId , teamId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/users/' + userId + '/team-changelogs/' + teamId
    });
  }

  getUser(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/users/' + id
    });
  }

  getRestrictedClients(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/users/' + id + '/allowed-clients'
    });
  }

  updateRestrictedClients(id, clients) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/admin/users/' + id + '/allowed-clients',
      data: clients
    });
  }

  addSite(site) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/sites',
      data: site
    });
  }

  updateSite(id, site) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/sites/' + id,
      data: site
    });
  }

  deleteSite(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/sites/' + id
    });
  }

  addTeam(team) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/teams',
      data: team
    });
  }

  updateTeam(id, team) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/teams/' + id,
      data: team
    });
  }

  deleteTeam(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/teams/' + id,
    });
  }

  addProblem(problem) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/problems',
      data: problem
    });
  }

  updateProblem(id, problem) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/problems/' + id,
      data: problem
    });
  }

  deleteProblem(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/problems/' + id
    });
  }

  addUser(user) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/users',
      data: {
        ...user,
        host: location.origin
      }
    });
  }

  resendPasswordEmail(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/users/' + id + '/password',
      data: {
        host: location.origin
      }
    });
  }

  updateUser(id, user) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/users/' + id,
      data: user
    });
  }

  unblockUser(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/users/' + id + '/blockedAt'
    });
  }

  getTeams() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/teams'
    });
  }

  getTeam(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/teams/' + id
    });
  }

  getSuggestedProcessClientConfigurations(teamId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/teams/' + teamId + '/suggestedProcessClientConfigurations'
    });
  }

  getProcessCountryConfigurations(country) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/countries/' + country + '/processGroupCountryConfigurations'
    });
  }

  getClientWithConfiguration(teamId, clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/teams/' + teamId + '/clients/' + clientId
    });
  }

  updateClientProcess(proc) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/processClientConfigurations/' + proc.id,
      data: proc
    });
  }

  removeClientFromTeam(teamId, clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/teams/' + teamId + '/clients/' + clientId
    });
  }

  addPosition(userId, position) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/users/' + userId + '/positions',
      data: position
    });
  }

  updatePosition(userId, positionId, position) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root +'/admin/users/' + userId + '/positions/' + positionId,
      data: position
    });
  }

  getRates() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/rates'
    });
  }

  getSites() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/sites'
    });
  }

  changeProcessRequirements(group_id, process_id, requirement) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/processGroupCountryConfigurations/' + group_id + '/' + process_id + '/force',
      data: requirement
    });
  }

  setOvertimeMode(overtime) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/overtimeManagementModes',
      data: overtime
    });
  }

  updateOvertime(overtime) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/overtimeManagementModes/' + overtime.id,
      data: overtime
    });
  }

  getVendors() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/vendors'
    });
  }

  setVendor(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/vendors',
      data
    });
  }

  updateVendor(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/vendors/' + id,
      data
    });
  }

  deleteVendor(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/vendors/' + id,
    });
  }

  regenerateApiKeys(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/vendors/${id}/regenerateToken`
    });
  }

  getInvitations() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/license-agreements'
    });
  }

  sendInvitation(invitation) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/license-agreements',
      data: invitation
    });
  }

  deleteInvitation(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/license-agreements/' + id
    });
  }

  resendInvitation(id, email) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/license-agreements/' + id + '/resend',
      data: {
        email: email
      }
    });
  }

//----------------PROJECTS-------------------------
  getProjectsForClient(clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/admin/projects/' + clientId,
    });
  }

  makeSyncERPprojects(clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/caseman-projects/sync/client/' + clientId,
    });
  }

  addProjectForClient(project) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/projects',
      data: project
    });
  }

  editProjectForClient(project, projectId) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/projects/' + projectId,
      data: project
    });
  }

  archiveProject(projectId) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/projects/' + projectId + '/archive'
    });
  }

  activateProject(projectId) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/admin/projects/' + projectId + '/activate'
    });
  }

  createOrUpdateOutputList(id, list) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/admin/processes/' + id + '/outputs',
      data: {
        outputs: list
      }
    });
  }

  turnProblemOn(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/problemProcessGroupConfigurations',
      data: data
    });
  }

  turnProblemOff(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/admin/problemProcessGroupConfigurations/' + id
    });
  }

  getUserProfitabilitySubscription(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/${userId}/subscriptions/profitability`
    });
  }

  createUserProfitabilitySubscription(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/profitability`,
      data: data
    });
  }

  updateUserProfitabilitySubscription(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/subscriptions/profitability/${id}`,
      data: data
    });
  }

  deleteUserProfitabilitySubscription(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/subscriptions/profitability/${id}`
    });
  }

  sendSubscriptionManually(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/profitability/${id}/email`
    });
  }

  getUserOvertimeSubscription(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/${userId}/subscriptions/overtime`
    });
  }

  createUserOvertimeSubscription(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/overtime`,
      data: data
    });
  }

  updateUserOvertimeSubscription(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/subscriptions/overtime/${id}`,
      data: data
    });
  }

  deleteUserOvertimeSubscription(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/subscriptions/overtime/${id}`
    });
  }

  sendOvertimeSubscriptionManually(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/overtime/${id}/email`
    });
  }

  getWorktimeConfig(country) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/countries/${country}/legal/worktime-config`
    });
  }

  createWorktimeConfig(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/legal/worktime-config',
      data: data
    });
  }

  deleteWorktimeConfig(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/admin/legal/worktime-config/${id}`
    });
  }

  editWorktimeConfig(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/admin/legal/worktime-config/${data.id}`,
      data: data
    });
  }

  getAddressees(country) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/countries/${country}/subscriptions/worktime/addressees`
    });
  }

  setAddressees(country, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + `/admin/countries/${country}/subscriptions/worktime/addressees`,
      data: data
    });
  }

  createUserLegalRuleAlert(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/worktime`,
      data: data
    });
  }

  updateUserLegalRuleAlert(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/subscriptions/worktime/${id}`,
      data: data
    });
  }

  deleteUserLegalRuleAlert(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/subscriptions/worktime/${id}`
    });
  }

  sendLegalRuleAlert(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/worktime/${id}/email`
    });
  }

  getUserLegalSubscription(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/${userId}/subscriptions/worktime`
    });
  }

  getSubsForCountry(country) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/countries/${country}/subscriptions`
    });
  }

  getUserSubordinateTeams(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/users/${id}/teams/subordinate`
    });
  }

  getUserSubordinateTeamsOverwrites(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/admin/users/${id}/teams/subordinate/overwrite`
    });
  }

  overwriteSubordinateTeams(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/admin/users/${id}/teams/subordinate/overwrite`,
      data: data
    });
  }

  removeSubordinateTeamOverwrite(userId, overwriteId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/admin/users/${userId}/teams/subordinate/overwrite/${overwriteId}`
    });
  }

  getAutomationTechnologyForCountry(country) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/countries/${country}/automation`
    });
  }

  createAutomationTechnology(country, data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/admin/countries/${country}/automation`,
      data: data
    });
  }

  updateAutomationTechnology(country, id, newAutomationName) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/admin/countries/${country}/automation/${id}`,
      data: {newAutomationName}
    });
  }

  deleteAutomationTechnology(country, id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/admin/countries/${country}/automation/${id}`
    });
  }

  exportAutomationDashboardData(country, params) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/countries/${country}/automation/process-client/report`,
      params,
      responseType: params && params.changesOnly ? 'blob' : 'arraybuffer'
    });
  }

  getMdpClients(clientName) {
    return this.ItCache.get(
      `MDP_clients_${clientName}`,
      () =>
        this.Auth.httpWithAuthToken({
          method: 'POST',
          url: this.API.root + '/admin/mdp-clients',
          data: {
            clientName: clientName
          }
        }),
      60 * 60 * 1000
    );
  }

  getDuplicatedClients(country) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/countries/${country}/clients/waitlist`
    });
  }

  acceptOrDeclineWaitingClient(country, id, status) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/admin/countries/${country}/clients/waitlist/${id}`,
      data: {
        status: status
      }
    });
  }

  getClientNotes(clientId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/note/process-client/report`,
      params: {
        clientId
      },
      responseType: 'arraybuffer'
    });
  }

  getCountryBillingTypes(countryName) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/countries/${countryName}/billing-type`
    });
  }

  createCountryBillingType(countryName, billingTypeName) {
    return this.Auth.httpWithAuthToken({ 
      method: 'POST',
      url: this.API.root + `/admin/countries/${countryName}/billing-type`,
      data: {
        billingTypeName
      }
    });
  }

  updateCountryBillingType(countryName, billingTypeId, newBillingTypeName) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/admin/countries/${countryName}/billing-type/${billingTypeId}`,
      data: {
        newBillingTypeName
      }
    });
  }

  deleteCountryBillingType(countryName, billingTypeId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/admin/countries/${countryName}/billing-type/${billingTypeId}`
    });
  }

  exportTeamsInCountryData(country, params) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/countries/${country}/teams/report`,
      params,
      responseType: params && params.changesOnly ? 'blob' : 'arraybuffer'
    });
  }

  getUserOvertimeRequestSubscriptions(userId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/${userId}/subscriptions/overtime-application`
    });
  }

  createUserOvertimeRequestsSubscription(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/overtime-application`,
      data: data
    });
  }

  updateUserOvertimeRequestsSubscription(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/subscriptions/overtime-application/${id}`,
      data: data
    });
  }

  deleteUserOvertimeRequestsSubscription(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/subscriptions/overtime-application/${id}`
    });
  }

  sendOvertimeRequestsSubscriptionManually(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/overtime-application/${id}/email`
    });
  }

  getProfitCenters() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/profit-centers`
    });
  }

  addProfitCenter(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/admin/profit-center`,
      data: data
    });
  }

  updateProfitCenter(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/admin/profit-center/${id}`,
      data: data
    });
  }

  deleteProfitCenter(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/admin/profit-center/${id}`
    });
  }

  getActiveUsersSubscriptions() {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/admin/subscriptions/active-users`
    });
  }

  createActiveUsersSubscription(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/active-users`,
      data: data
    });
  }

  updateActiveUsersSubscription(id, data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/subscriptions/active-users/${id}`,
      data: data
    });
  }

  deleteActiveUsersSubscription(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/subscriptions/active-users/${id}`
    });
  }

  sendActiveUsersSubscriptionManually(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/subscriptions/active-users/${id}/email`
    });
  }
}
